import type { EnvironmentResourceListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { EnvironmentsResponse } from '../../models/environments.model';

export function mapEnvironmentsResponse({
  data,
  pagination,
}: EnvironmentResourceListResponseApi): EnvironmentsResponse {
  return { data, pagination };
}
